// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { UserService } from '@services/user.service';
import { RouteGuardService } from '@services/route-guard.service';

@Injectable({
    providedIn: 'root',
})
export class SystemDocsToSignGuard implements CanActivate {
    constructor(
        private readonly router: Router,
        private readonly userService: UserService,
        private readonly routeGuardService: RouteGuardService
    ) {}

    async canActivate(): Promise<boolean> {
        const user = this.userService.user;

        let canActivateEvaluation = false;

        if (user?.needToAcceptSystemDocument) {
            await this.router.navigate(['systemDocument']);
            canActivateEvaluation = false;
        } else {
            canActivateEvaluation = true;
        }

        this.routeGuardService.logRouteGuard(this.constructor.name, canActivateEvaluation);

        return canActivateEvaluation;
    }
}
